var sheet = function () {
  if (typeof document === 'undefined') return;
  var style = document.createElement('style');
  document.head.appendChild(style);
  return style.sheet;
}();

export { sheet };
